import { render, staticRenderFns } from "./Titular.vue?vue&type=template&id=7a9c4f19"
import script from "./Titular.vue?vue&type=script&lang=js"
export * from "./Titular.vue?vue&type=script&lang=js"
import style0 from "./Titular.vue?vue&type=style&index=0&id=7a9c4f19&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports